export default __webpack_public_path__ + "static/media/screwdriver-wrench.3f05e932.svg";